/** @format */

import { ListItem } from '@/app/[locale]/(protected)/(dashboard)/ui/DashboardAccountsListItem';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import Link from '@atoms/Link';
import { DocumentClient } from '@common/model/apiClient';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

interface DashboardDocListItemProps {
  doc: DocumentClient & { accountName?: string };
}

const Title = styled.span`
  color: var(--black);
  font-weight: bold;
  font-size: 1.25rem;
  padding-block: 2px;
  > span {
    font-weight: normal;
    font-size: 0.8rem;
    color: var(--grey-500);
    margin-inline: 4px;
  }
`;

const Author = styled.span`
  color: var(--grey-500);
  font-size: 14px;
  padding-block: 2px;
`;

const Total = styled.span`
  color: var(--black);
  font-size: 1rem;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
`;

const Description = styled.span`
  color: var(--grey-500);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  //flex: 0.5;
  //max-width: calc(100% - 80px);
`;

const AccountName = styled.span`
  color: var(--black);
  //font-weight: bold;
`;

function DashboardDocListItem({ doc }: DashboardDocListItemProps) {
  const selectedCurrency = useConfigStore((s) => s.currency);
  const intl = useIntl();
  return (
    <Link href={`/account/${doc.accountId}/document/${doc.id}`}>
      <ListItem>
        <Header>
          <Title>
            {doc.title}
            <span>({doc.id})</span>
          </Title>
          {(doc.accountName || doc.account?.name) && <AccountName>{doc.accountName ?? doc.account.name}</AccountName>}
        </Header>
        {Number(doc.savingsTotal) > 0 && <Total>{intl.formatNumber(Number(doc.savingsTotal), { style: 'currency', currency: selectedCurrency?.iso4217 })}</Total>}
        <Description>{JSON.parse(doc?.description ?? null)?.blocks?.[0]?.text}</Description>
        {doc.author && (
          <Author>
            {doc.author?.givenName} {doc.author?.familyName}
          </Author>
        )}
      </ListItem>
    </Link>
  );
}

export default DashboardDocListItem;
